/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { CardContent } from '../../../Shared/Card'
import { Icon, IconGroup } from 'semantic-ui-react'

const NoCheckoutSystemCardContent = () => {
    return (
      <CardContent
        css={css`
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            gap: 1rem;
        `}
      >
          <IconGroup size="big">
              <Icon color="grey" name="plug"/>
              <Icon corner name="ban" color="grey"/>
          </IconGroup>
          <p
            css={css`
                margin-right: .5rem;
                font-weight: bold;
            `}>Aucun système de caisse</p>
      </CardContent>
    )
}

export { NoCheckoutSystemCardContent }
